import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PlaylistSection = ({ playlists, onPlaylistClick }) => {
  return (
    <div className="playlist-section">
      <div className="section-header mb-6">
        <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
          Плейлисты и серии
        </h2>
        <p className="text-sm text-muted-foreground">
          Тематические подборки лучшего контента
        </p>
      </div>
      <div className="playlists-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {playlists?.map((playlist) => (
          <div
            key={playlist?.id}
            className="playlist-card bg-card rounded-lg border border-border overflow-hidden hover:shadow-soft transition-all duration-200 cursor-pointer"
            onClick={() => onPlaylistClick(playlist)}
          >
            <div className="playlist-artwork relative aspect-video overflow-hidden bg-muted">
              <Image 
                src={playlist?.coverImage} 
                alt={playlist?.coverImageAlt}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent flex items-end p-4">
                <div className="flex items-center gap-2 text-white">
                  <Icon name="ListMusic" size={16} color="white" />
                  <span className="text-sm font-mono">{playlist?.episodeCount} эфиров</span>
                </div>
              </div>
            </div>

            <div className="playlist-info p-4">
              <h3 className="text-lg font-heading font-semibold text-foreground mb-2 line-clamp-1">
                {playlist?.title}
              </h3>
              <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
                {playlist?.description}
              </p>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
                  <span className="font-mono">{playlist?.totalDuration}</span>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="Play"
                  iconPosition="left"
                >
                  Слушать
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlaylistSection;